import { getLocalDate } from 'localization/utils/getLocalDate'

const getShortDisplay = (utcDate: string) => {
  return getLocalDate(utcDate)
}

export default getShortDisplay
